class Metrics {
  private metricsGateway = `https://m-w.dev.mobileposse.com`
  // private metricsGateway = `http://localhost:8080`

  private commonLabelAndValues: any

  constructor() {
    this.commonLabelAndValues = {
      env: window?.mp_globals?.env?.environment,
      platform: window?.mp_globals?.env?.platform,
      page: window.location.pathname,
      content_domain: window.location.host
    }
  }

  public histogram(metricName: string, value: number, labelsAndValues: Partial<Record<string, string>>) {
    try {
      const payload = JSON.stringify({
        name: `neptune_content_${metricName}`,
        value,
        labels: { ...this.commonLabelAndValues, ...labelsAndValues }
      })
      fetch(`${this.metricsGateway}/m/h`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: payload
      }).then()
    } catch (error) {}
  }

  public counter(metricName: string, labelsAndValues: Partial<Record<string, string>>) {
    try {
      const payload = JSON.stringify({
        name: `neptune_content_${metricName}`,
        labels: { ...this.commonLabelAndValues, ...labelsAndValues }
      })
      fetch(`${this.metricsGateway}/m/c-inc`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: payload
      }).then()
    } catch (error) {}
  }
}

// Create a singleton instance of the Metrics class
const metricsInstance = new Metrics()

// Export the instance
export default metricsInstance
